// MST
import { types, flow, detach, cast } from 'mobx-state-tree'

// Interfaces
import { ICertificationWebpageFinalFinishAttrs } from 'interfaces/webpage/certification/registration/final/final-view.interface'
import { ICertificationWebpageFinalApiFinishResponse } from 'interfaces/webpage/certification/registration/final/final-api.interface'
import { ISharedCommonLoadingAttrs } from 'interfaces/shared/shared-common.interface'

// Extensions
import { withEnvironment } from 'models/extensions/with-environment'
import { withHelper_commonLoadingModel, withHelper_commonMapLoading } from 'models/extensions/helper'

// Constant
import { LOADING } from 'constant/shared.constant'

// Types
const { model, optional } = types

// Loading
const { ACTION } = LOADING

const CertificationWebpageFinalModel = model('CertificationWebpageFinal')
  .props({
    certificationWebpageFinal_loading: withHelper_commonLoadingModel,
  })
  .actions(self => ({
    certificationWebpageFinal_SET_LOADING: (payload: ISharedCommonLoadingAttrs): void => {
      const map = withHelper_commonMapLoading(self.certificationWebpageFinal_loading, payload)

      detach(self.certificationWebpageFinal_loading)
      self.certificationWebpageFinal_loading = cast(map)
    },
  }))
  .extend(withEnvironment)
  .actions(self => ({
    /**
     * @description Finish certificate registration
     *
     * @param {ICertificationWebpageFinalFinishAttrs} payload
     *
     * @return {any} any
     */
    certificationWebpageFinal_finish: flow(function* (payload: ICertificationWebpageFinalFinishAttrs) {
      self.certificationWebpageFinal_SET_LOADING({ type: ACTION, value: true })

      const response: ICertificationWebpageFinalApiFinishResponse =
        yield self.environment.certificationWebpageFinalApi.certificationWebpageFinal_finish({
          params: { ...payload.params },
          requestConfig: { ...payload.requestConfig },
        })

      // Do when response success
      if (response.ok) {
        if (payload?.onSuccess) payload.onSuccess()
      }

      // Do when response failed
      if (!response.ok) {
        if (payload?.onError) payload.onError()
      }

      self.certificationWebpageFinal_SET_LOADING({ type: ACTION, value: false })
    }),
  }))

export const createCertificationWebpageFinalDefaultModel = () => optional(CertificationWebpageFinalModel, {})
